var map = {
	"./ar.yml": 30570,
	"./ca.yml": 59079,
	"./en.yml": 45446,
	"./es.yml": 99271,
	"./fr.yml": 67514,
	"./hi.yml": 76661,
	"./it.yml": 39350,
	"./nl.yml": 50633,
	"./pt.yml": 24182,
	"./ro.yml": 12772,
	"./ru.yml": 23798,
	"./sw.yml": 37059,
	"./zh.yml": 29874
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7320;